"use client";

import { AppProgressProvider as ProgressProvider } from "@bprogress/next";

const TopLoader = ({
	children,
}: Readonly<{
	children: React.ReactNode;
}>) => {
	return (
		<ProgressProvider
			height="4px"
			color="#A9F958"
			options={{ showSpinner: false }}
			shallowRouting
		>
			{children}
		</ProgressProvider>
	);
};

export default TopLoader;
